import React from "react";
import {
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Row,
  Col,
  Icon,
  Button,
  RSelect,
} from "../../Component";

const MedicalPartnerListToolbar = ({
  onSearchText,
  onFilterChange,
  filters,
  statusOptions,
  countryOptions,
  tcApprovalOptions,
  hasListFilters,
  clearAllListFilters,
  openAddPartnerModal,
  loading,
}) => (
  <div className="card-inner border-bottom">
    <Row className="g-2 align-items-center">
      <Col md="5" lg="4">
        <input
          type="search"
          className="form-control"
          placeholder="Search organization, contact, email…"
          value={onSearchText}
          onChange={(e) => onFilterChange(e)}
          aria-label="Search partners"
        />
      </Col>
      <Col md="7" lg="8" className="d-flex flex-wrap align-items-center justify-content-md-end gap-2">
        <UncontrolledDropdown>
          <DropdownToggle tag="button" type="button" className="btn btn-light btn-sm dropdown-toggle">
            <Icon name="filter-alt" className="me-1" />
            Filters
            {hasListFilters ? <span className="badge bg-primary ml-2">On</span> : null}
          </DropdownToggle>
          <DropdownMenu right className="filter-wg dropdown-menu-xl" style={{ overflow: "visible" }}>
            <div className="dropdown-head">
              <span className="sub-title dropdown-title">Refine list</span>
            </div>
            <div className="dropdown-body dropdown-body-rg">
              <Row className="gx-6 gy-3">
                <Col size="6">
                  <FormGroup className="mb-0">
                    <label className="overline-title overline-title-alt">Workflow (visibility)</label>
                    <RSelect
                      options={statusOptions}
                      value={statusOptions.find((option) => option.value === filters.status)}
                      onChange={(e) => onFilterChange(e, "status")}
                      placeholder="Any"
                      isClearable
                    />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup className="mb-0">
                    <label className="overline-title overline-title-alt">Country</label>
                    <RSelect
                      options={countryOptions}
                      value={countryOptions.find((option) => option.value === filters.country)}
                      onChange={(e) => onFilterChange(e, "country")}
                      placeholder="Any"
                      isClearable
                    />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup className="mb-0">
                    <label className="overline-title overline-title-alt">Created</label>
                    <input type="date" className="form-control" value={filters.date} onChange={(e) => onFilterChange(e, "date")} />
                  </FormGroup>
                </Col>
                <Col size="6">
                  <FormGroup className="mb-0">
                    <label className="overline-title overline-title-alt">Teleconsultation</label>
                    <RSelect
                      options={tcApprovalOptions}
                      value={tcApprovalOptions.find((option) => option.value === filters.tcApproval)}
                      onChange={(e) => onFilterChange(e, "tcApproval")}
                      placeholder="Any"
                      isClearable
                    />
                  </FormGroup>
                </Col>
                <Col size="12">
                  <Button color="light" size="sm" type="button" className="mt-1" onClick={clearAllListFilters}>
                    Clear search &amp; filters
                  </Button>
                </Col>
              </Row>
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>
        <button type="button" className="btn btn-primary btn-sm" onClick={openAddPartnerModal} disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-1" />
              Loading…
            </>
          ) : (
            <>
              <Icon name="plus" />
              <span className="ml-1">New partner</span>
            </>
          )}
        </button>
      </Col>
    </Row>
  </div>
);

export default MedicalPartnerListToolbar;
